/* Fantastick V8.9 – optional playing-card and Roman-text modes. */
(function (w) {
  'use strict';
  if (w.FantastickSpecialModes && w.FantastickSpecialModes.version === '8.9.0') return;
  var SUITS = { diamond: 'Karo', spade: 'Pik', heart: 'Herz', club: 'Kreuz' };
  var COLORS = { black: 'Schwarz', red: 'Rot', white: 'Weiß' };
  var ROMAN_VALUES = [[1000,'M'],[900,'CM'],[500,'D'],[400,'CD'],[100,'C'],[90,'XC'],[50,'L'],[40,'XL'],[10,'X'],[9,'IX'],[5,'V'],[4,'IV'],[1,'I']];
  function clamp(value, min, max, fallback) { var n=value == null || value === '' ? Number(fallback) : Number(value); return Math.max(min, Math.min(max, Number.isFinite(n) ? n : min)); }
  function romanize(input) {
    var raw=String(input || ''), invalid='';
    var output=raw.replace(/[0-9]+/g, function (digits) {
      var n=Number(digits);
      if (!Number.isSafeInteger(n) || n < 1 || n > 3999) { invalid='Zahlen müssen zwischen 1 und 3999 liegen; für 0 gibt es keine klassische römische Zahl.'; return ''; }
      var result='';
      ROMAN_VALUES.forEach(function (pair) { while (n >= pair[0]) { result+=pair[1]; n-=pair[0]; } });
      return result;
    });
    return { ok:!invalid, output:output, error:invalid };
  }
  function cleanCard(value) { return Array.from(String(value || '').normalize('NFC').toLocaleUpperCase('de-DE').replace(/[^\p{L}0-9]/gu,'')).slice(0,2).join(''); }
  function clone(obj) { return JSON.parse(JSON.stringify(obj)); }
  function text(el,value) { if (el && el.textContent !== value) el.textContent=value; }
  function setHidden(node,hidden) {
    if (!node) return;
    if (hidden && !node.hasAttribute('data-fkc-special-hidden')) {
      if (node.hidden) return;
      node.dataset.fkcSpecialHidden='true'; node.hidden=true;
    } else if (!hidden && node.hasAttribute('data-fkc-special-hidden')) {
      node.removeAttribute('data-fkc-special-hidden'); node.hidden=false;
    }
  }
  function Controller(instance,config) {
    this.i=instance; this.root=instance.root; this.config=config;
    this.fontState={cards:'idle',roman:'idle'}; this.fontTasks={}; this.loadedUrl='';
    this.attached=false; this.basePositionEnabled=instance.positionSelectorEnabled;
  }
  Controller.prototype.initState=function () {
    this.i.state.specialModes={cards:{suit:'spade',color:'black',value:''},roman:{value:''}};
  };
  Controller.prototype.restore=function (data) {
    if (!data || typeof data !== 'object') return;
    var s=this.i.state.specialModes;
    if (data.cards && typeof data.cards === 'object') {
      if (SUITS[data.cards.suit]) s.cards.suit=data.cards.suit;
      if (COLORS[data.cards.color]) s.cards.color=data.cards.color;
      if (typeof data.cards.value === 'string') s.cards.value=cleanCard(data.cards.value);
    }
    if (data.roman && typeof data.roman.value === 'string') s.roman.value=Array.from(data.roman.value.replace(/[\r\n\t]+/g,' ')).slice(0,40).join('');
  };
  Controller.prototype.reset=function () { this.initState(); this.loadedUrl=''; };
  Controller.prototype.mode=function () {
    var key=this.i.state && this.i.state.motifKey;
    if (key === 'special:cards' && this.config.cards) return 'cards';
    if (key === 'special:roman' && this.config.roman) return 'roman';
    return '';
  };
  Controller.prototype.cardUrl=function () {
    var s=this.i.state.specialModes.cards, images=this.config.cards && this.config.cards.images;
    return images && images[s.suit] && images[s.suit][s.color] || '';
  };
  Controller.prototype.installMotifs=function () {
    var i=this.i, self=this;
    i.motifs=i.motifs.filter(function (m) { return !m.specialMode; });
    i.motifCategories=i.motifCategories.filter(function (category) { return !String(category.key).startsWith('special-category:'); });
    i.motifCategories.forEach(function (category) { category.keys=(category.keys || []).filter(function (key) { return !String(key).startsWith('special:'); }); });
    if (i.motifs.slice(1).some(function (m) { return m.source === 'legacy'; }) && !i.motifCategories.some(function (c) { return c.key === 'legacy'; })) {
      i.motifCategories.push({key:'legacy',label:'Weitere Motive',keys:i.motifs.filter(function(m){return m.source === 'legacy';}).map(function(m){return m.key;})});
    }
    var modes=['cards','roman'].filter(function (mode) { return !!self.config[mode]; }).map(function (mode) {
      var c=self.config[mode], label=String(c.category || 'Besondere Motive').trim() || 'Besondere Motive';
      var category=i.motifCategories.find(function (x) { return String(x.label).trim().toLocaleLowerCase('de-DE') === label.toLocaleLowerCase('de-DE'); });
      if (!category) { category={key:'special-category:'+label.toLocaleLowerCase('de-DE'),label:label,keys:[]}; i.motifCategories.push(category); }
      var motif={key:'special:'+mode,label:String(c.title || (mode === 'cards' ? 'Spielkarten' : 'Römische Zahlen')),source:'special',specialMode:mode,categoryKeys:[category.key],imageUrl:'',sizePercent:100,gap:0,x:0,y:0,rotation:0};
      category.keys.push(motif.key); return {motif:motif,sort:clamp(c.sort,0,50,0)};
    });
    modes.sort(function (a,b) { return (a.sort || 999)-(b.sort || 999); });
    modes.forEach(function (entry) { var index=entry.sort ? Math.min(entry.sort,i.motifs.length) : i.motifs.length; i.motifs.splice(index,0,entry.motif); });
    if (modes.length) i.motifEnabled=true;
    if (i.state && i.state.specialModes) this.updateMotifImage();
  };
  Controller.prototype.updateMotifImage=function () {
    var motif=this.i.motifs.find(function (m) { return m.specialMode === 'cards'; });
    if (motif && this.i.state.specialModes) { motif.imageUrl=this.cardUrl(); motif.thumbnailUrl=motif.imageUrl; }
  };
  Controller.prototype.renderText=function (fieldKey) {
    var first=this.i.textFields[0], mode=this.mode();
    if (!first || fieldKey !== first.key) return mode === 'cards' ? '' : String(this.i.state.textValues[fieldKey] || '');
    if (mode === 'cards') return this.i.state.specialModes.cards.value;
    if (mode === 'roman') { var r=romanize(this.i.state.specialModes.roman.value); return r.ok ? r.output : ''; }
    return String(this.i.state.textValues[fieldKey] || '');
  };
  Controller.prototype.fontFor=function (fieldKey) {
    var mode=this.mode(), first=this.i.textFields[0];
    if (!mode || !first || first.key !== fieldKey) return null;
    var cfg=this.config[mode];
    return {key:'special:'+mode,name:cfg.fontName || cfg.fontFile || (mode === 'cards' ? 'Spielkartenschrift' : 'Römische Schrift'),family:cfg.fontFamily,weight:'400',style:'normal',transferSource:'file:'+String(cfg.fontFile || '')};
  };
  Controller.prototype.colorFor=function (fieldKey) {
    if (this.mode() !== 'cards' || this.i.textFields[0].key !== fieldKey) return null;
    var key=this.i.state.specialModes.cards.color;
    return {key:'special:'+key,name:COLORS[key],fill:this.config.cards.colors[key]};
  };
  Controller.prototype.ensureFont=async function () {
    var mode=this.mode(); if (!mode) return true;
    var cfg=this.config[mode], self=this;
    if (!cfg.fontFile || !cfg.fontFamily || !document.fonts || typeof document.fonts.load !== 'function') { this.fontState[mode]='missing'; this.sync(); return false; }
    if (this.fontState[mode] === 'ready') return true;
    if (this.fontTasks[mode]) return this.fontTasks[mode];
    this.fontState[mode]='loading'; this.sync();
    this.fontTasks[mode]=(async function () {
      var timeout;
      try {
        var limit=new Promise(function (_,reject) { timeout=w.setTimeout(function(){reject(new Error('font timeout'));},8000); });
        var faces=await Promise.race([document.fonts.load('normal 400 48px "'+cfg.fontFamily+'"', 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'),limit]);
        self.fontState[mode]=faces && faces.length ? 'ready' : 'missing';
      } catch (_) { self.fontState[mode]='missing'; }
      finally { w.clearTimeout(timeout); }
      self.fontTasks[mode]=null;
      if (self.i.root.isConnected && self.mode() === mode) { self.sync(); self.i.queueLayout(); }
      return self.fontState[mode] === 'ready';
    })();
    return this.fontTasks[mode];
  };
  Controller.prototype.error=function () {
    var mode=this.mode(); if (!mode) return '';
    var s=this.i.state.specialModes, cfg=this.config[mode];
    if (mode === 'cards') {
      if (!s.cards.value) return 'Bitte ein oder zwei Buchstaben oder Zahlen eingeben.';
      if (!this.cardUrl()) return this.i.config.designMode ? 'Für dieses Symbol und diese Farbe fehlt das Bild im Spielkarten-Block.' : 'Dieses Symbol ist in der gewählten Farbe momentan nicht verfügbar.';
    } else {
      if (!s.roman.value.trim()) return 'Bitte Text oder ein Datum eingeben.';
      var converted=romanize(s.roman.value);
      if (!converted.ok) return converted.error;
      if (Array.from(converted.output).length > this.i.textFields[0].maxChars) return 'Der umgewandelte Sticktext ist zu lang. Bitte kürze die Eingabe.';
    }
    if (!cfg.fontFile) return this.i.config.designMode ? 'Bitte eine WOFF2-Schriftdatei im zugehörigen Modus-Block hinterlegen.' : 'Diese Gestaltung ist momentan nicht verfügbar.';
    if (this.fontState[mode] === 'loading' || this.fontState[mode] === 'idle') return 'Schrift wird geladen …';
    if (this.fontState[mode] !== 'ready') return this.i.config.designMode ? 'Die WOFF2-Schrift konnte nicht geladen werden. Dateiname und Datei prüfen.' : 'Diese Schrift ist momentan nicht verfügbar.';
    if (mode === 'cards' && (!this.i.motifObject || this.loadedUrl !== this.cardUrl())) return 'Motiv wird geladen oder ist gerade nicht verfügbar.';
    return '';
  };
  Controller.prototype.sync=function () {
    if (!this.attached || !this.i.state.specialModes) return;
    var i=this.i, mode=this.mode(), state=i.state.specialModes, first=i.textFields[0], self=this;
    this.updateMotifImage();
    this.root.querySelectorAll('[data-fkc-special-panel]').forEach(function (p) { p.hidden=p.dataset.fkcSpecialPanel !== mode; });
    this.root.querySelectorAll('[data-fkc-text-module]').forEach(function (n) { setHidden(n,mode === 'cards' || mode === 'roman' && n.dataset.fkcTextKey === first.key); });
    this.root.querySelectorAll('[data-fkc-style-module]').forEach(function (n) { setHidden(n,mode === 'cards'); });
    i.elements.fontSelects.forEach(function (s) { setHidden(s.closest('.fkc__field-group'),!!mode && s.dataset.fkcTextKey === first.key); });
    var textStep=this.root.querySelector('[data-fkc-tour-area="text"]');
    setHidden(textStep,mode === 'cards' || mode === 'roman' && i.textFields.length === 1);
    setHidden(this.root.querySelector('[data-fkc-tour-area="style"]'),mode === 'cards');
    i.positionSelectorEnabled=mode === 'cards' ? this.config.positionAllowed === true : this.basePositionEnabled;
    var positionStep=this.root.querySelector('[data-fkc-tour-area="position"]');
    if (positionStep && mode === 'cards' && i.positionSelectorEnabled && positionStep.hidden && !positionStep.hasAttribute('data-fkc-special-hidden')) {
      positionStep.dataset.fkcSpecialForcedPosition='true'; positionStep.hidden=false;
    } else if (positionStep && mode !== 'cards' && positionStep.hasAttribute('data-fkc-special-forced-position')) {
      positionStep.hidden=true;positionStep.removeAttribute('data-fkc-special-forced-position');
    }
    if (!this.stepLabels) this.stepLabels=Array.from(i.elements.form.querySelectorAll(':scope > .fkc__step')).map(function (step) {
      var label=step.querySelector('.fkc__step-number'); return {step:step,label:label,original:label && label.textContent};
    });
    var visibleNumber=0;
    this.stepLabels.forEach(function (entry) {
      if (!entry.label) return;
      if (mode) { if (!entry.step.hidden) entry.label.textContent=String(++visibleNumber); }
      else entry.label.textContent=entry.original;
    });
    var cardInput=this.root.querySelector('[data-fkc-card-text]'), romanInput=this.root.querySelector('[data-fkc-roman-text]');
    if (cardInput && cardInput.value !== state.cards.value) cardInput.value=state.cards.value;
    if (romanInput) { romanInput.maxLength=first.maxChars; if (romanInput.value !== state.roman.value) romanInput.value=state.roman.value; }
    this.root.querySelectorAll('[data-fkc-card-suit]').forEach(function (button) {
      var suit=button.dataset.fkcCardSuit, img=button.querySelector('img'), glyph=button.querySelector('[data-fkc-card-symbol]');
      button.setAttribute('aria-pressed',String(suit === state.cards.suit));
      var url=self.config.cards && self.config.cards.images && self.config.cards.images[suit] && self.config.cards.images[suit][state.cards.color];
      if (img) { if (url) { if (img.getAttribute('src') !== url) img.setAttribute('src',url); img.hidden=false; img.style.backgroundColor=state.cards.color === 'white' ? '#777' : 'transparent'; } else { img.removeAttribute('src'); img.hidden=true; } }
      if (glyph) glyph.hidden=!!url;
    });
    this.root.querySelectorAll('[data-fkc-card-color]').forEach(function (button) { button.setAttribute('aria-pressed',String(button.dataset.fkcCardColor === state.cards.color)); });
    if (this.config.roman) {
      var roman=romanize(state.roman.value), output=roman.ok && roman.output ? roman.output : '–';
      text(this.root.querySelector('[data-fkc-roman-output]'),output);
      text(this.root.querySelector('[data-fkc-roman-counter]'),'Eingabe: '+Array.from(state.roman.value).length+'/'+first.maxChars+' · Sticktext: '+Array.from(roman.ok ? roman.output : '').length+'/'+first.maxChars);
    }
    ['cards','roman'].forEach(function (name) { text(self.root.querySelector('[data-fkc-special-status="'+name+'"]'),mode === name ? self.error() : ''); });
    if (i.elements && i.elements.addButton) i.updatePurchaseAvailability();
  };
  Controller.prototype.attach=function () {
    if (this.attached) return; this.attached=true;
    var self=this, i=this.i;
    i.listen(this.root,'click',function (event) {
      var suit=event.target.closest('[data-fkc-card-suit]'), color=event.target.closest('[data-fkc-card-color]');
      if (i.busy || self.mode() !== 'cards' || !suit && !color) return;
      if (suit && SUITS[suit.dataset.fkcCardSuit]) i.state.specialModes.cards.suit=suit.dataset.fkcCardSuit;
      if (color && COLORS[color.dataset.fkcCardColor]) i.state.specialModes.cards.color=color.dataset.fkcCardColor;
      self.loadedUrl=''; self.updateMotifImage(); i.saveState(); i.setStatus(''); self.sync();
      i.loadSelectedMotif();
    });
    [['cards','[data-fkc-card-text]'],['roman','[data-fkc-roman-text]']].forEach(function (pair) {
      var input=self.root.querySelector(pair[1]); if (!input) return;
      i.listen(input,'input',function () {
        if (pair[0] === 'cards') i.state.specialModes.cards.value=cleanCard(input.value);
        else i.state.specialModes.roman.value=Array.from(input.value.replace(/[\r\n\t]+/g,' ')).slice(0,i.textFields[0].maxChars).join('');
        i.saveState(); i.setStatus(''); self.sync(); i.queueLayout();
      });
      i.listen(input,'focus',function () { i.setTextEntryMode(true,input); });
      i.listen(input,'blur',function () { i.setTextEntryMode(false,input); });
    });
    this.sync();
  };
  Controller.prototype.focusInput=function () { var node=this.root.querySelector(this.mode() === 'cards' ? '[data-fkc-card-text]' : '[data-fkc-roman-text]'); if (node) { node.focus({preventScroll:true}); node.scrollIntoView({behavior:'smooth',block:'center'}); } };
  Controller.prototype.orderSelections=function (selections) {
    var mode=this.mode(); if (!mode) return selections;
    var first=Object.assign({},selections[0]), field=Object.assign({},first.field,{required:true});
    first.field=field; first.input=this.root.querySelector(mode === 'cards' ? '[data-fkc-card-text]' : '[data-fkc-roman-text]'); first.text=this.renderText(field.key).trim(); first.font=this.fontFor(field.key); first.color=this.colorFor(field.key) || first.color;
    if (mode === 'cards') { field.cartLabel='Kartenwert'; field.heading='Kartenwert'; return [first]; }
    field.heading='Text oder Datum'; return [first].concat(selections.slice(1));
  };
  Controller.prototype.snapshot=function () {
    var mode=this.mode(); if (!mode) return null; var cfg=this.config[mode], s=this.i.state.specialModes;
    if (mode === 'cards') return {mode:'cards',value:s.cards.value,suit:s.cards.suit,suitLabel:SUITS[s.cards.suit],color:s.cards.color,colorLabel:COLORS[s.cards.color],colorValue:cfg.colors[s.cards.color],imageUrl:this.cardUrl(),fontFile:cfg.fontFile,fontName:cfg.fontName,placement:this.cardSettings()};
    return {mode:'roman',input:s.roman.value,output:romanize(s.roman.value).output,fontFile:cfg.fontFile,fontName:cfg.fontName};
  };
  Controller.prototype.orderLabel=function (motif) { var info=this.snapshot(); return info && info.mode === 'cards' ? 'Spielkarte – '+info.suitLabel : motif.label; };
  Controller.prototype.appendProperties=function (form) {
    var info=this.snapshot(); if (!info) return;
    form.append('properties[Gestaltungsmodus]',info.mode === 'cards' ? 'Spielkarte' : 'Römische Zahlen');
    if (info.mode === 'cards') { form.append('properties[Kartensymbol]',info.suitLabel); form.append('properties[_Kartensymbol-Datei]',info.imageUrl); }
    else form.append('properties[Eingabe vor Umwandlung]',info.input);
  };
  Controller.prototype.cardSettings=function () {
    var i=this.i, vals=i.getCalibration()[i.state.alignKey], v=vals.playingCard || {}, first=i.textFields[0], old=vals.texts && vals.texts[first.key] || {};
    return {
      x:clamp(v.x,0,100,vals.groupX == null ? 50 : vals.groupX),
      y:clamp(v.y,0,100,vals.groupY == null ? 50 : vals.groupY),
      symbolSize:clamp(v.symbolSize,2,60,vals.motifSize == null ? 20 : vals.motifSize),
      textSize:clamp(v.textSize,2,20,old.size == null ? 7 : old.size),
      gap:clamp(v.gap,0,15,2),rotation:clamp(v.rotation,-180,180,vals.groupRotation == null ? 0 : vals.groupRotation)
    };
  };
  Controller.prototype.calibrationFields=function (background) {
    var i=this.i,a=i.state.alignKey,defaults=this.cardSettings();
    background.forEach(function (field) { field.groupLabel='Mockup'; });
    [
      {name:'x',label:'Spielkarte horizontal',min:0,max:100,step:.5,unit:'%'},
      {name:'y',label:'Spielkarte vertikal',min:0,max:100,step:.5,unit:'%'},
      {name:'symbolSize',label:'Kartensymbol Größe',min:2,max:60,step:.5,unit:'%'},
      {name:'textSize',label:'Kartenwert Größe',min:2,max:20,step:.25,unit:'%'},
      {name:'gap',label:'Abstand Symbol zu Text',min:0,max:15,step:.25,unit:'%'},
      {name:'rotation',label:'Spielkarte Drehung',min:-180,max:180,step:1,unit:'°'}
    ].forEach(function (v) { background.push(Object.assign({},v,{path:a+'.playingCard.'+v.name,fallback:defaults[v.name],groupLabel:'Spielkarte – '+(a === 'right' ? 'Rechts' : 'Mittig')})); });
    return background;
  };
  Controller.prototype.applyCard=function () {
    var i=this.i, field=i.textFields[0], v=this.cardSettings(), state=i.state.specialModes.cards;
    var x=v.x*i.logicalWidth/100, y=v.y*i.logicalHeight/100, width=v.symbolSize*i.logicalWidth/100;
    var fontSize=v.textSize*i.logicalWidth/100, gap=v.gap*i.logicalHeight/100, angle=v.rotation;
    var font=this.fontFor(field.key), color=this.colorFor(field.key), obj=i.textObjects[field.key], motif=i.motifObject;
    obj.set({text:state.value || 'A',fontFamily:font.family,fontWeight:'400',fontStyle:'normal',fontSize:fontSize,fill:color.fill,opacity:state.value ? 1 : .48,originX:'center',originY:'center',textAlign:'center',scaleX:1,scaleY:1});obj.initDimensions();
    if (obj.width > width*1.5) { obj.set('fontSize',fontSize*width*1.5/obj.width);obj.initDimensions(); }
    i.textFields.slice(1).forEach(function (f) { i.textObjects[f.key].set('opacity',0); });
    if (motif) i.scaleMotifToWidth(width);
    var h=motif ? motif.getScaledHeight() : 0, th=obj.getScaledHeight(), top=y-(h+gap+th)/2;
    function rotated(dx,dy) { var r=angle*Math.PI/180;return {x:x+dx*Math.cos(r)-dy*Math.sin(r),y:y+dx*Math.sin(r)+dy*Math.cos(r)}; }
    if (motif) { var mp=rotated(0,top+h/2-y);motif.set({originX:'center',originY:'center',left:mp.x,top:mp.y,angle:angle});motif.setCoords(); }
    var tp=rotated(0,top+h+gap+th/2-y);obj.set({left:tp.x,top:tp.y,angle:angle});obj.setCoords();
    var objects=motif ? [motif,obj] : [obj];i.clampObjectsToCanvasAsGroup(objects);
    objects.forEach(function (o) { var b=o.getBoundingRect(true,true);if (b.left < -.5 || b.top < -.5 || b.left+b.width > i.logicalWidth+.5 || b.top+b.height > i.logicalHeight+.5) i.layoutError='Diese Spielkarte passt nicht vollständig in die Vorschau. Bitte Position oder Größe anpassen.'; });
  };
  function create(instance) {
    var node=instance.root.querySelector('[data-fkc-special-config]'); if (!node) return null;
    var config=JSON.parse(node.textContent);if (!config.cards && !config.roman) return null;
    return new Controller(instance,config);
  }
  w.FantastickSpecialModes={version:'8.9.0',create:create,romanize:romanize,cleanCard:cleanCard};
})(window);
